var exports = {
  "W": "LogoMarquee__S2ns5t",
  "k": "LogoMarquee--dark__VgGvgs",
};

module.exports = exports;
